/**
 * @description This file contains the configuration for the application.
 * It is used to define global constants and variables.
 */
export const garminTileTokenIntervalDelay = 270000; // milliseconds

export default garminTileTokenIntervalDelay;
